import 'whatwg-fetch';
import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    window.addEventListener('paymentReady', (event) => {
      this.processForm(event.detail.payment_method_id, event.detail.button);
    });
  }

  setPaymentIdInput(id) {
    let paymentMethodIdInput = document.querySelector(
      `#${this.element.id} input[name='payment_method_id']`
    );
    paymentMethodIdInput.setAttribute('value', id);
  }

  processForm(paymentId, buttonElement) {
    buttonElement.disabled = true;
    this.setPaymentIdInput(paymentId);
    this.element.submit();
  }
}
